'use client';


const Link = props => (
  <div
    onClick={() => {
      if (props.href.startsWith('/')) {
        window.location.href = props.href;
      } else if (props.href.startsWith('#')) {
        const element = document.querySelector(props.href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          // If element not found and we're not on root, go to root and scroll
          if (window.location.pathname !== '/') {
            window.location.href = `/${props.href}`;
          }
        }
      }
    }}
    style={{
      cursor: 'pointer',
      color: 'rgba(255, 255, 255, 0.6)',
      textDecoration: 'none',
      overflow: 'hidden',
    }}
  >
    {props.label}
  </div>
);

export default Link;
